/**
 * ES2022 `Array.prototype.at` / `String.prototype.at` polyfill.
 *
 * `.at()` shipped in Safari/iOS 15.4. Patients on Safari 15.0–15.3 (older macOS
 * and iOS 15 devices that cannot upgrade) still reach the call view, whose
 * layout hooks call `.at(-1)`. Without this shim the call throws a `TypeError`,
 * trips the ErrorBoundary, and crash-loops the consultation. esbuild's
 * browserslist target only lowers *syntax* and never polyfills runtime methods,
 * and the app ships no core-js / legacy plugin — so the method must be provided
 * explicitly. Imported first in `main.tsx`, before any code that uses `.at`.
 */
/** Spec-compliant `.at` implementation; exported for direct unit testing. */
export function at(this: ArrayLike<unknown>, index: number): unknown {
  const { length } = this;
  const relativeIndex = Math.trunc(index) || 0;
  const absoluteIndex =
    relativeIndex < 0 ? length + relativeIndex : relativeIndex;
  return absoluteIndex < 0 || absoluteIndex >= length
    ? undefined
    : this[absoluteIndex];
}

if (typeof Array.prototype.at !== 'function') {
  Object.defineProperty(Array.prototype, 'at', {
    value: at,
    writable: true,
    enumerable: false,
    configurable: true,
  });
}

if (typeof String.prototype.at !== 'function') {
  Object.defineProperty(String.prototype, 'at', {
    value: at,
    writable: true,
    enumerable: false,
    configurable: true,
  });
}
